export type AppEnvironment = "development" | "production";

export function resolveAppEnvironment(value: string | undefined): AppEnvironment {
  return value?.trim().toLowerCase() === "development"
    ? "development"
    : "production";
}

export const APP_ENVIRONMENT = resolveAppEnvironment(
  process.env.NEXT_PUBLIC_APP_ENV,
);

export const IS_DEVELOPMENT_ENVIRONMENT = APP_ENVIRONMENT === "development";
